import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { AllDeviceInfo } from '@interfaces';
import { DeviceInfoService } from '@core/services/device-info.service';
import { MfaInfoModalComponent } from './mfa-info-modal.component';

@Injectable()
export class MfaInfoModalService {
  private readonly dialog = inject(MatDialog);
  private readonly deviceInfoService = inject(DeviceInfoService);
  private readonly mobileDialogWidth = '96vw';
  private readonly mobileDialogMaxHeight = '90dvh';

  public dialogRef: MatDialogRef<any>;
  public name = 'mfa-info-modal';
  public deviceInfo: AllDeviceInfo;
  private dialogWidth = '600px';
  private dialogHeight: string | undefined = '460px';
  private dialogTop = '12vh';

  constructor() {
    this.deviceInfo = this.deviceInfoService.getInfo();
    if (this.deviceInfo.deviceTypeDetected !== 'DESKTOP') {
      this.dialogWidth = this.mobileDialogWidth;
      this.dialogHeight = undefined;
      this.dialogTop = '5dvh';
    }
  }

  public open(): MatDialogRef<MfaInfoModalComponent, boolean> {
    this.deviceInfo = this.deviceInfoService.getInfo();
    if (this.deviceInfo.deviceTypeDetected !== 'DESKTOP') {
      this.dialogWidth = this.mobileDialogWidth;
      this.dialogHeight = undefined;
      this.dialogTop = '5dvh';
    }
    this.dialogRef = this.dialog.open(MfaInfoModalComponent, {
      width: this.dialogWidth,
      maxWidth: this.dialogWidth,
      height: this.dialogHeight,
      maxHeight: this.mobileDialogMaxHeight,
      position: { top: this.dialogTop },
      panelClass: ['mfa-info-modal'],
      data: { mobileBackButtonClose: false },
      autoFocus: false,
      disableClose: true,
      closeOnNavigation: true,
    });

    return this.dialogRef;
  }
}
